module.exports = __webpack_public_path__ + "media/images/desktop/meeting-14893e6008b5761fc35191f10e141fe2.svg";